import { create } from "zustand";
import { materialService } from "../services/materialService";

const useMaterialStore = create((set, get) => ({
  materials: [],

  fetchMaterials: async () => {
    try {
      const response = await materialService.getMaterial();

      if (response?.Data) {
        set({ materials: response.Data });
        // console.log("material data: ", response.Data);
      } else {
        console.warn("No materials found in response.");
      }
    } catch (error) {
      console.error("Error fetching materials:", error);
    }
  },
}));

export default useMaterialStore;
